import React, {useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useWindowSize} from '../../../hooks'

import Image from '../Image'

import QRCode from 'react-qr-code'

import Button from '@mui/material/Button'
import PrintIcon from '@mui/icons-material/Print'

import {AspectImage, CkordLogo} from '../../generics'




const styles = {
  root: css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column;
    position: relative;
    overflow: hidden;

    @media print {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 100;
      margin: 0;
      -webkit-print-color-adjust: exact;

      @page {
        margin: 0; 
      }
    }
  `,
  letterAspectRatioBox: css`
    width: 900px;
    height: 0;
    padding-top: calc(900px * 11 / 8.5);
    position: relative;
    margin: 0;
    background-color: black;
    transform-origin: center center;

    @media print {
      width: 100%;
      height: 100%;
      padding-top: 0;
      transform: scale(1) !important;
    }
  `,
  letterAspectRatioBoxInside: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: black;
  `,
  outsideImageContainer: css`
    width: 100%;
    display: flex;
    justify-content: center;
  `,
  insideImageContainer: css`
    position: relative;
    width: 100%;
    padding: 30px;
  `,
  gradient: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-image: linear-gradient(to bottom, transparent, transparent, transparent, rgba(0, 0, 0, 0.4), #000);
  `,
  logoContainer: css`
    display: flex;
    width: 100%;
    justify-content: flex-start;
  `,
  body: css`
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 130px;
    gap: 30px;
    flex: 1 0;
    z-index: 20;
  `,
  nameContainer: css`
    display: flex;
    flex-grow: 1;
    container-type: inline-size;
  `,
  name: css`
    text-transform: uppercase;
    font-size: 18cqw;
    z-index: 10;
    margin: 0;
    color: #fff;
    line-height: 0.9;
    margin-bottom: -15px;
    font-family: Gravity, Avenir Next, Arial Black, sans-serif;
  `,
  qrcode: css`
    width: 165px;
    height: 165px;
    min-width: 165px;
    padding: 15px;
    background-color: #fff;
  `,
  controlsContainer: css`
    margin-top: 15px;
    background-color: transparent;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media print {
      display: none;
    }
  `,
  button: css`
    height: 50px;
    width: 140px;
    border-radius: 25px;
    border: 1px solid #fff;
    padding-right: 20px;
    padding-left: 20px; 
  `
}




const Flier = props => {

  const {id, type, image, name} = props

  const url = process.env.REACT_APP_API_URL + `/${type}s/` + id + '?utm_source=affiliate&utm_medium=qrcode&utm_campaign=code_scan'


  const size = useWindowSize()



  useEffect(() => {
    const wrapper = document.getElementById('flier')
    const container = document.getElementById('printable-flier')


    const scale = Math.min(
      1,
      wrapper.offsetWidth / container.offsetWidth, 
      wrapper.offsetHeight / container.offsetHeight, 
    )


    container.style.transform = `scale(${scale})`
  }, [size])




  useEffect(() => {
    window.addEventListener('beforeprint', handlePrint)
    window.addEventListener('afterprint', handlePrintComplete)


    function handlePrint(e) {
      const root = document.getElementById('app')
      root?.classList.add('hide-from-print')
    }


    function handlePrintComplete(e) {
      const root = document.getElementById('app')
      root?.classList.remove('hide-from-print')
    }


    return () => {
      window.removeEventListener('beforeprint', handlePrint)
      window.removeEventListener('afterprint', handlePrintComplete)
    }
  }, [])




  function print() {
    window.print()
  }





  return (
    <div id='flier' css={styles.root}>
      <div id='printable-flier' css={styles.letterAspectRatioBox}>
        <div css={styles.letterAspectRatioBoxInside}>
          <div css={styles.outsideImageContainer}>
            <div css={styles.insideImageContainer}>
              <div css={styles.gradient}></div>

              <div css={styles.logoContainer}>
                <CkordLogo style={{color: '#fff', fontSize: '32px', marginBottom: '5px'}} />
              </div>

              <AspectImage src={image} borderRadius='0px' alt='qr code profile poster' />
            </div>
          </div>


          <div css={styles.body}>
            <div css={styles.nameContainer}>
              <h1 css={styles.name}>
                {name}
              </h1>
            </div>

            <div css={styles.qrcode}>
              <QRCode value={url} style={{height: 'auto', maxWidth: '100%', width: '100%'}} />
            </div>
          </div>
        </div>
      </div>

      <div css={styles.controlsContainer}>
        <Button css={styles.button} onClick={print} endIcon={<PrintIcon />}>
          PRINT 
        </Button>
      </div>
    </div>
  )
}


export default Flier


